import { useState, useEffect } from 'react';

import Card from './card';
import { BattleshipGameTypes, CardData, GridData } from './types';
import { checkIfShipDestroyed } from './grid-generator';

// audio imports
import shipHitFile from '../../assets/audio/cannon-shot-hit-explosion.mp3'; 
import shipSunkFile from '../../assets/audio/cannon-shot-hit-sink-ship.mp3'; 
import missShotFile from '../../assets/audio/cannon-shot-miss-splash.mp3';
import missfireFile from '../../assets/audio/cannon-missfire.mp3';


interface Props {
    gridData: GridData[];
    rows: number;
    cols: number;
    eventLogo?: string | null;
    gameType: BattleshipGameTypes;
    maxQuestionDuration?: number | null;
    incorrectAnswerCooldownSeconds?: number | null;
    onCorrectAnswer: (gridItem: CardData, userAnswer?: string) => void;
    onIncorrectAnswer: (gridItem: CardData, userAnswer?: string) => void;
}

export const Board = (props: Props) => {
    const [windowDimentions, setWindowDimentions] = useState<{ windowWidth: number; windowHeight: number }>({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight
    });
    const shipHit = new Audio(shipHitFile);
    const shipSunk = new Audio(shipSunkFile);
    const missShot = new Audio(missShotFile);
    const missfire = new Audio(missfireFile);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleResize = () => {
        setWindowDimentions({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    };

    const handleIncorrectAnswer = (cardData: CardData, userAnswer?: string) => {
        missfire.play();
        // use timeout to give time for the animation to complete
        setTimeout(() => {
            if (props.onIncorrectAnswer) {
                props.onIncorrectAnswer(cardData, userAnswer);
            }
        }, 1000);
    };

    const handleQuestionAnswered = (cardData: CardData, userAnswer?: string) => {
        if(cardData.shipTeam) {
            if(checkIfShipDestroyed(props.gridData, cardData)){
                shipSunk.play();
            } else {
                shipHit.play();
            }
        } else {
            missShot.play();
        }
        // use timeout to give time for the animation to complete
        setTimeout(() => {
            if (props.onCorrectAnswer) {
                props.onCorrectAnswer(cardData, userAnswer);
            }
        }, 1000);
    };

    let headerHeight = windowDimentions.windowWidth > 640 ? 60 : 32,
        cardWidth = windowDimentions.windowWidth / props.cols,
        cardHeight = (windowDimentions.windowHeight - headerHeight) / props.rows,
        cardComponents: JSX.Element[] = [];

    props.gridData.forEach((columnData, columnDataIndex) => {
        let left = columnDataIndex * cardWidth;
        columnData.cardRows.forEach((cardData, cardIndex) => {
            cardComponents.push(
                <Card
                    onIncorrectAnswer={handleIncorrectAnswer}
                    onCorrectAnswer={handleQuestionAnswered}
                    column={columnDataIndex}
                    row={cardIndex}
                    left={left}
                    top={cardIndex * cardHeight + headerHeight}
                    height={cardHeight}
                    width={cardWidth}
                    cardData={cardData}
                    key={columnDataIndex + '-' + cardIndex}
                    eventLogo={props.eventLogo}
                    gameType={props.gameType}
                    maxQuestionDuration={props.maxQuestionDuration}
                    incorrectAnswerCooldownSeconds={props.incorrectAnswerCooldownSeconds}
                />
            );
        });
    });

    return <>{cardComponents}</>;
};
